import { Card, Col, Flex, Image, Row, Space } from 'antd';
import { useEffect, useState } from 'react';
import { typeSeatItems } from '../../../components/BusTypeMatrix';
import { Constant } from '../../../config/constant';
import { SeatRenderProps } from '../../../types/seatType';

const SeatMapSegment = ({ seatMatrixData }: SeatRenderProps) => {
  const [seatMatrix, setSeatMatrix] = useState<{ [key: string]: any }>({
    floor1: [],
    floor2: [],
    group_seat: [],
  });

  const getGroupColor = (seatName: string) => {
    return (
      seatMatrix?.group_seat.find((group: any) => {
        return group?.selected_seat ? group.selected_seat?.includes(seatName) : '';
      })?.group_color || ''
    );
  };

  const renderColor = (seatFloors: any) => {
    return (
      typeSeatItems?.find((item: any) => +item?.id === +seatFloors.type)?.image && (
        <Space className="bus-type-item group" style={{ columnGap: '4px' }}>
          <Image
            src={typeSeatItems?.find((item: any) => +item?.id === +seatFloors.type)?.image}
            alt=""
            width={60}
            preview={false}
            style={{ maxHeight: '40px' }}
            className={`${+seatFloors.type > Constant.EXTRA_DRIVER_SEAT && getGroupColor(seatFloors.name)} horizontal`}
          />
        </Space>
      )
    );
  };
  useEffect(() => {
    if (seatMatrixData) {
      setSeatMatrix(seatMatrixData);
    }
  }, [seatMatrixData, seatMatrix]);

  return (
    <Flex gap={16} className="mt-4 block-seat-render">
      <div className={`seat-render-content floor-1 group`}>
        <p className="fs-14 fw-500 mt-3" style={{ color: '#667085' }}>
          Tầng 1
        </p>
        {seatMatrix[`floor1`]?.map((rowSeats: any, rowIndex: number) => (
          <Row key={rowIndex} className={`seat-list group mt-2`} style={{ flexWrap: 'nowrap' }}>
            {rowSeats?.map((seatFloors: any, colIndex: number) => (
              <Col key={colIndex}>
                <Card
                  style={{ width: 54, height: 54, border: 'none' }}
                  className={`card-seat-item mt-2`}
                  bodyStyle={{ display: 'none' }}
                  cover={
                    +seatFloors.type !== Constant.DEFAULT_SEAT && (
                      <Space
                        className={`seat-block-item render${
                          typeSeatItems?.find((item: any) => +item?.id === +seatFloors.type)?.image ? ' ic-type' : ''
                        }`}
                      >
                        <Space className="ic-type-seat">{renderColor(seatFloors)}</Space>
                      </Space>
                    )
                  }
                ></Card>
              </Col>
            ))}
          </Row>
        ))}
      </div>
      {seatMatrix?.count_floor === 2 ? (
        <div className={`seat-render-content group floor-2`}>
          <p className="fs-14 fw-500 mt-3" style={{ color: '#667085' }}>
            Tầng 2
          </p>
          {seatMatrix[`floor2`]?.map((rowSeats: any, rowIndex: number) => (
            <Row key={rowIndex} className={`seat-list group mt-2`} style={{ flexWrap: 'nowrap' }}>
              {rowSeats?.map((seatFloors: any, colIndex: number) => (
                <Col key={colIndex}>
                  <Card
                    style={{ width: 54, height: 54, border: 'none' }}
                    className={`card-seat-item mt-2`}
                    bodyStyle={{ display: 'none' }}
                    cover={
                      +seatFloors.type !== Constant.DEFAULT_SEAT && (
                        <Space
                          className={`seat-block-item render${
                            typeSeatItems?.find((item: any) => +item?.id === +seatFloors.type)?.image ? ' ic-type' : ''
                          }`}
                        >
                          <Space className="ic-type-seat">{renderColor(seatFloors)}</Space>
                        </Space>
                      )
                    }
                  ></Card>
                </Col>
              ))}
            </Row>
          ))}
        </div>
      ) : (
        ''
      )}
    </Flex>
  );
};
export default SeatMapSegment;
